import type { IntegrationProperty } from 'entities/Integrations/model'

export const propertiesDnDFiltered = (properties?: IntegrationProperty[], itemsDnD?: string[]) => {
  const items = properties || []

  if (!itemsDnD) return items

  return itemsDnD.reduce<IntegrationProperty[]>((state, key) => {
    const property = items.find((item) => item.key === key)

    if (property) state.push(property)

    return state
  }, [])
}
